<template>
     <td v-if="editDisabled">
     </td>
    <td v-else-if="!dataItem['inEdit']">
        <button 
        class="k-button k-grid-remove-command"
        @click="removeHandler">
         Povrni
              
    </button>
    <span title="Status shranjevanja" v-if="dataItem.saved!=undefined" :class="[dataItem.saved?'action_success':'action_error','k-badge','k-badge-solid','k-badge-md','k-badge-pill']">
    <font-awesome-icon v-if="dataItem.saved" icon="check" class='action_success'/> 
    <font-awesome-icon v-else icon="times"/> 
    </span>
    </td>
<td v-else>
    
     <button 
       class="k-button k-grid-remove-command"
       @click="removeHandler">
       Odstrani
              
    </button>
    
    <button  v-if="!dataItem._id"
            class="k-button k-grid-cancel-command"
            @click="cancelDiscardHandler">
            {{dataItem._id? 'Prekliči' : 'Zavrzi'}}
    </button>

    <span title="Status shranjevanja" v-if="dataItem.saved!=undefined" :class="[dataItem.saved?'action_success':'action_error','k-badge','k-badge-solid','k-badge-md','k-badge-pill']">
    <font-awesome-icon v-if="dataItem.saved" icon="check" class='action_success'/> 
    <font-awesome-icon v-else icon="times"/> 
    </span>
</td>
</template>
<script>

export default {
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        editDisabled:Boolean
    },
    
    methods: {
        editHandler: function() {
            console.log(this.dataItem);
            this.$emit('edit', {dataItem:this.dataItem});
        },
        removeHandler: function() {
            this.$emit('remove', {dataItem:this.dataItem});
        },
        addUpdateHandler: function() {
            this.$emit('save', {dataItem:this.dataItem});
        },
        cancelDiscardHandler: function() {
            this.$emit('cancel', {dataItem:this.dataItem});
        }
    }
}
</script>